<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="950"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          {{ title }}
        </v-card-title>

        <v-card-text light>
          <code
            class="d-block w-100 text-xs-left"
          >{{ debugObject }}
          </code>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="isVisible = false"
          >
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'HolderDebugDialog',
  components: {
  },
  props: {
    visible: Boolean,
    debugObject: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>
<style lang="scss" />



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/shared/DebugDialog.vue